var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2543",
    "data-name": "Grupo 2543",
    transform: "translate(-118 -276)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1705",
    "data-name": "Ret\\xE2ngulo 1705",
    width: 35,
    height: 35,
    rx: 10,
    transform: "translate(118 276)",
    fill: "#d3ff9a",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_twotone_empty-wallet",
    "data-name": "vuesax/twotone/empty-wallet",
    transform: "translate(-112 94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.54,5.8a2.008,2.008,0,0,0-.6,1.63A2.132,2.132,0,0,0,17.1,9.3H19v1.19a3.768,3.768,0,0,1-3.76,3.76H3.76A3.768,3.768,0,0,1,0,10.49V3.76A3.768,3.768,0,0,1,3.76,0H15.24A3.768,3.768,0,0,1,19,3.76V5.2H16.98A1.993,1.993,0,0,0,15.54,5.8Z",
    transform: "translate(238.5 195.75)",
    fill: "none",
    stroke: "#d3ff9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,10.364V5.794a2.848,2.848,0,0,1,1.84-2.67l7.94-3A1.9,1.9,0,0,1,12.35,1.9V5.7",
    transform: "translate(238.5 190.046)",
    fill: "none",
    stroke: "#d3ff9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.129,1.02V3.08a1.027,1.027,0,0,1-1,1.02H2.169A2.132,2.132,0,0,1,.009,2.23,2.008,2.008,0,0,1,.609.6,1.993,1.993,0,0,1,2.049,0h2.08A1.027,1.027,0,0,1,5.129,1.02Z",
    transform: "translate(253.431 200.95)",
    fill: "none",
    stroke: "#d3ff9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H7",
    transform: "translate(243 200)",
    fill: "none",
    stroke: "#d3ff9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(236 188)",
    fill: "none",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBalance);
export default __webpack_public_path__ + "static/media/wallet-balance.bcd8fc63b36cf220b64d875b7e2fad11.svg";
export { ForwardRef as ReactComponent };